require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-megha-gulati.json") })
        }
      }, "path---blog-author-megha-gulati");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-megha-gulati!./.cache/json/blog-author-megha-gulati.json
// module id = 677
// module chunks = 231608221292675